<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sidebar-unfold`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.314 29.693a1.19 1.19 0 00-1.183 1.069l-.007.121v10.234a1.19 1.19 0 001.69 1.08l.115-.061 8.488-5.117a1.188 1.188 0 00.107-1.965l-.107-.073-8.489-5.117a1.189 1.189 0 00-.614-.17zM21 34a1 1 0 00-1 1v2a1 1 0 001 1h22a1 1 0 001-1v-2a1 1 0 00-1-1H21zM9 20a1 1 0 00-1 1v2a1 1 0 001 1h34a1 1 0 001-1v-2a1 1 0 00-1-1H9zM9 6a1 1 0 00-1 1v2a1 1 0 001 1h34a1 1 0 001-1V7a1 1 0 00-1-1H9z"/></svg>
</template>
<script>

export default {
  name: 'IconSidebarUnfold',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
